module.exports = {
	"history": {
		"title": "35 ANNI VISSUTI CON ORGOGLIO",
		"label": "LA NOSTRA STORIA",
		"p1": "Elcon Megarad è la società italiana leader nella progettazione e produzione di accessori per cavi di bassa, media e alta tensione.",
		"p2": "Dal 1981 sviluppiamo soluzioni specifiche per giunti e terminali con qualità certificata. Grazie alla passione per la ricerca e l’innovazione tecnologica, siamo il punto di riferimento qualificato per gli addetti al settore di tutto il mondo.",
		"advCaption": "Pubblicità anni 90"
	},
	"quote": {
		"text": "Ogni giorno mettiamo tutte le nostre competenze e la nostra energia a servizio di quella dei nostri clienti. Elcon Megarad: colleghiamo l’energia da 35 anni."
	},
	"map": {
		"title": "È QUI CHE PRODUCIAMO RICERCA E INNOVAZIONE",
		"label": "DOVE SIAMO",
		"p1": "Siamo gli <strong>unici in Italia</strong> a produrre e assemblare i propri prodotti interamente “in house”.",
		"avTitle": "Arcella",
		"avCity": "Avellino",
		"avDivision": "Divisione Cable Accessories",
		"ceTitle": "Mignano Monte Lungo",
		"ceCity": "Caserta",
		"ceDivision": "Divisione Chemical"
	},
	"newProducts": {
		"title": "I PRODOTTI CHE SEGNERANNO GLI ANNI A VENIRE",
		"label": "NUOVI PRODOTTI",
		"p1": "Elconext, il terminale sconnettibile a cono esterno; Elcon VTS, la gamma di terminali preformati autoretraibili; Elcold GLS 89RR, il giunto monoblocco ultra compatto. Il nostro contributo al <strong>progresso</strong> dell’intero comparto.",
		"link": "Scheda Tecnica",
		"slide1": "GIUNTI RETRAIBILI A FREDDO",
		"slide2": "TERMINALI RETRAIBILI A FREDDO",
		"slide3": "ELCONEXT. Terminale sconnettibile a cono esterno"
	},
	"allProducts": {
		"title": "I COMPONENTI E GLI ACCESSORI CHE CI HANNO RESI GRANDI",
		"label": "CATALOGO",
		"p1": "Progettiamo e offriamo al mercato le tecnologie più <strong>affidabili</strong>, così come attestato dalle Certificazioni Internazionali e dai numerosi tentativi di imitazione!",
		"catGen": "Generale",
		"catLowVolt": "Accessori bassa tensione",
		"catMidVolt": "Accessori media tensione",
		"catHighVolt": "Accessori alta tensione",
		"catPrinted": "Guaine e parti stampate",
		"catTape": "Mastici, Nastri e Resine",
		"subcatLowVolt1": "Giunti e terminali bassa tensione per applicazioni speciali",
		"subcatLowVolt2": "Giunti e terminali per cavi bassa tensione",
		"subcatMidVolt1": "Giunti per cavi media tensione",
		"subcatMidVolt2": "Terminali per cavi media tensione",
		"subcatMidVolt3": "Giunti e terminali per impianti eolici e fotovoltaici",
		"subcatMidVolt4": "Collegamenti in cavo unipolare",
		"subcatHighVolt1": "Giunti termorestringenti per cavi 52kV",
		"subcatHighVolt2": "Terminali termorestringenti per cavi 52kV",
		"subcatPrinted1": "Guaine termorestringenti std",
		"subcatPrinted2": "Guaine termorestringenti a parete sottile",
		"subcatPrinted3": "Guaine termorestringenti speciali MT",
		"subcatPrinted4": "Guaine termorestringenti per applicazioni speciali",
		"subcatPrinted5": "Guaine termorestringenti per applicazioni automotive",
		"subcatPrinted6": "Guaine termorestringenti speciali multistrato MT",
		"subcatPrinted7": "Parti stampate termorestringenti",
		"subcatTape1": "Mastici",
		"subcatTape2": "Nastri",
		"subcatTape3": "Resine"
	},
	"places": {
		"title": "UNA STORIA CHE SCRIVIAMO OGNI GIORNO IN OLTRE 50 PAESI",
		"label": "ULTIME ISTALLAZIONI",
		"p1": "Non solo Prodotti performanti e certificati, ma anche un eccellente servizio pre e post vendita personalizzato.",
		"p2": "Sono queste le ragioni principali che portano <strong>clienti da ogni parte del mondo</strong> a fidarsi di noi da 35 anni.",
		"dubai": "dubai",
		"hannover": "hannover"
	},
	"certs": {
		"title": "CERTIFICAZIONI",
		"label": "CERTIFICAZIONI",
		"link": "Elenco Completo"
	},
	"footer": {
		"label": "Vai al sito",
		"link": "Vai al sito"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./web/locales/it.json
 ** module id = 261
 ** module chunks = 0
 **/